import { render, staticRenderFns } from "./Sheet_Why.vue?vue&type=template&id=60dddfa2&scoped=true"
import script from "./Sheet_Why.vue?vue&type=script&lang=js"
export * from "./Sheet_Why.vue?vue&type=script&lang=js"
import style0 from "./Sheet_Why.vue?vue&type=style&index=0&id=60dddfa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dddfa2",
  null
  
)

export default component.exports